module.exports = __webpack_public_path__ + "static/media/radio.0745d290.png";